'use client';

import type { ReactNode } from 'react';
import { forwardRef } from 'react';

import { defineMessages, useIntl } from 'react-intl';

export type PrimaryNavigationContainerProps = {
  children: ReactNode;
  onMouseLeave: (event: React.MouseEvent<HTMLUListElement>) => void;
  primaryNavigationVisible: boolean;
};

const messages = defineMessages({
  primaryNavigationCategoryList: {
    id: 'primary.navigation.categories.list.label',
    defaultMessage: 'Hauptnavigationsliste',
  },
});
export const PrimaryNavigationContainer = forwardRef<
  HTMLUListElement | null,
  PrimaryNavigationContainerProps
>(({ children, onMouseLeave, primaryNavigationVisible }, ref) => {
  const { formatMessage } = useIntl();

  return (
    <ul
      ref={ref}
      className={`${
        primaryNavigationVisible ? 'max-lg:grid' : 'max-lg:hidden'
      } lg:max-h-[calc(theme(spacing[5.5])_+_2px)] lg:min-h-[calc(theme(spacing[5.5])_+_2px)] m-0 flex p-0 max-lg:m-0 max-lg:w-full max-lg:[grid-auto-rows:7.5rem] max-lg:[grid-template-columns:repeat(auto-fill,_minmax(10rem,1fr))] max-lg:place-items-stretch max-lg:gap-2 max-lg:px-1.5 max-lg:pt-4.5 max-lg:pb-1.5 lg:list-none lg:flex-wrap`}
      onMouseLeave={onMouseLeave}
      aria-label={formatMessage(messages.primaryNavigationCategoryList)}
    >
      {children}
    </ul>
  );
});
